<template>
  <div id="Cloud" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 ">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">s</span>ervicio de nube</div>
        <div class="col-3 f26 t-r color-primary"></div>
      </div>
    </div>
    <div class="h4"></div>
    <div class="col-12 t-c pt10 pb10">
      <img src="@/assets/cloud-service_5463868.png" class="r5 w15">
    </div>
    <div class="col-12" v-if="Object.keys(pageData).length === 0 || to_change">
      <div class="col-12">
        <div class="col-12 t-c pt10 pb10 lh22 f18 color-muted pl10 pr10">
          Paquete de servicios:
        </div>
        <div class="col-12 t-c pt10 pb10 pl10 pr10">
          <div class="col-12">
            <select v-model="selectedPackage" class="p10">
              <option v-for="plan in plan_list" :value="plan.id" :key="plan.id">{{ plan.plan_name }}</option>
            </select>
            <select v-model="selectedNumber" class="p10">
              <option v-for="number in numbers" :value="number" :key="number">{{ number }}</option>
            </select>
            <select v-model="paymentOption" class="p10">
              <option value="yearly">Año</option>
              <!-- <option value="monthly">Mes</option> -->
            </select>
          </div>
        </div>
        <div class="col-12 pt10 pb10 pl10 pr10 t-c-v" v-if="to_change == false">
          <div class="bg-color-primary r5 p10 color-white w30 t-c" @click="plan_select()">Confirmar</div>
        </div>
        <div class="col-12 pt10 pb10 pl10 pr10 t-c-v" v-else>
          <div class="bg-color-muted r5 p10 color-white col-6 t-c mr5" @click="toChange()">Vuelta</div>
          <div class="bg-color-primary r5 p10 color-white col-6 t-c ml5" @click="plan_select()">Confirmar</div>
        </div>
      </div> 
    </div>
    <div class="col-12" v-else>
      <div class="col-12 t-c pt10 lh22 f18 pl10 pr10 color-black">
        <i class="iconfont icon-cloud-link-full color-success"></i> {{ plan.plan_name }} 
        <i class="iconfont icon-add-circle color-success" @click="toChange(1)"></i>  
        <i class="iconfont icon-error color-danger" @click="plan_delete_confim()"></i>
      </div>
      <div class="col-12 t-c pt5 pb5 color-muted pl10 pr10 f14 mb30">
        Al servicio en la nube le quedan <span class="color-success f18">{{ pageData.exp_day}}</span> días
      </div>
      <div class="col-12 t-c pt10 pb10 pl10 pr10">
        <div class="col-6 pl20 pr20">
          <input type="text" v-model="newUser" class="p10 r5 b1" placeholder="Agregar usuario">
        </div>
        <div class="col-6 pl20 pr20">
          <div class="col-12 bg-color-primary r5 p10 color-white" @click="plan_user_add()">Confirmar</div>
        </div>
      </div>
      <div class="col-12 pl10 pr10">
          <div class="col-12 lh40">
            <i class="iconfont icon-arrow-right-filling color-primary"></i> Usuarios
          </div>
          <div class="col-12 bg-color-white bb1 lh40 r5 f14 mb5" v-for="(user, user_i) in user_list" :key="user_i">
            <div class="col-6 pl10">{{ user.name }}</div>
            <div class="col-6 pr10 t-r">{{ user.join_time }} <i class="iconfont icon-jian color-danger f18" @click="plan_user_delete_confim(user_i)"></i></div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Cloud',
  data () {
    return {
      appid: this.$route.query.appid,
      selectedPackage: '1',
      paymentOption: 'yearly',
      selectedNumber: '1',
      newUser: '',
      pageData: {},
      plan: {},
      plan_list: [],
      user_list: [],
      numbers: [1,2,3,4,5,6,7,8,9,10,11,12],
      to_change: false
    }
  },
  created: function () {
    this.get_cloud();
  },
  methods: {
    //获取云端信息
    get_cloud(){
      var post_data = {};
      post_data.appid = this.appid;
      this.post(this.api_url + 'Tec/cloud', post_data).then((res)=>{
        if(res.status == 1){
          if(res.data['cloud']){
            this.pageData = res.data['cloud'];
            this.plan = res.data['plan'];
            this.user_list = res.data['user_list'];
          }
          this.plan_list = res.data['plan_list'];
        }else{
          this.plan_list = res.data['plan_list'];
          this.data_status = 2;
        }
      })
    },
    //选择套餐
    plan_select(){
      var post_data = {};
      post_data.appid = this.appid;
      post_data.plan_id = this.selectedPackage;
      post_data.number = this.selectedNumber;
      post_data.payment = this.paymentOption;
      this.post(this.api_url + 'Tec/cloud_plan', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.to_change = false;
          this.get_cloud();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    //添加用户
    plan_user_add(){
      var post_data = {};
      post_data.appid = this.appid;
      post_data.user = this.newUser;
      this.post(this.api_url + 'Tec/cloud_user_add', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.get_cloud();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    //修改套餐
    toChange(){
      if(this.to_change == false){
        this.to_change = true;
      }else{
        this.to_change = false;
      }
    },
    //删除套餐确认
    plan_delete_confim(){
      this.$store.commit('setConfimBox',{type:'confim_exit',msg:'Confirmar para eliminar este paquete?',_this:this,focus:'',method:'plan_delete',arg1:''});
    },
    //删除用户确认
    plan_user_delete_confim(i){
      this.$store.commit('setConfimBox',{type:'confim_exit',msg:'Confirmar para eliminar este usuario?',_this:this,focus:'',method:'plan_user_delete',arg1:i});
    },
    //删除用户
    plan_user_delete(i){
      console.log(i);
      console.log(this.user_list[i]);
      var post_data = {};
      post_data.appid = this.appid;
      post_data.aid = this.user_list[i].aid;
      console.log(post_data);
      this.post(this.api_url + 'Tec/cloud_user_delete', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.get_cloud();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    //删除套餐
    plan_delete(){
      var post_data = {};
      post_data.appid = this.appid;
      this.post(this.api_url + 'Tec/cloud_plan_delete', post_data).then((res)=>{
        if(res.status == 1){
          this.get_cloud();
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Technician/Cloud.vue